import React from 'react';
import { AppButtonLink } from '../AppButton/AppButton';
import TradingTipCard from './TradingTipCard';
import './HomePage.css';

const Hero = () => {
    return (
        <section className="home-hero">
            <div className="home-hero-inner">
                <div className="home-hero-main">
                    <span className="home-eyebrow">Automated crypto trading</span>
                    <h1 className="home-hero-title">NeuraTrader</h1>
                    <p className="home-hero-subtitle">
                        Run algo, scheduled, and grid bots from one platform.
                        Connect your exchange, set your rules, and let NeuraTrader execute 24/7.
                    </p>

                    <div className="home-hero-badges">
                        <span className="home-hero-badge">Non-custodial</span>
                        <span className="home-hero-badge">Your API keys</span>
                        <span className="home-hero-badge">Spot &amp; futures</span>
                    </div>

                    <div className="home-hero-actions">
                        <AppButtonLink to="/register" variant="primary" size="md">
                            Get started free
                        </AppButtonLink>
                        <AppButtonLink to="/pricing" variant="secondary" size="md">
                            View pricing
                        </AppButtonLink>
                        <AppButtonLink to="/learn" variant="secondary" size="md">
                            Bot guides
                        </AppButtonLink>
                    </div>
                </div>

                <div className="home-hero-aside">
                    <TradingTipCard />
                </div>
            </div>
        </section>
    );
};

export default Hero;